import { Routes, Route, BrowserRouter } from "react-router";
import StudentSession from "./views/student/session";
import TeacherSession from "./views/teacher/session";
import GamesOverview from "./views/teacher/gamesOverview";
import NewGame from "./views/teacher/games/new";
import EditGame from "./views/teacher/games/edit";
import Footer from "./components/footer";
import Signup from "./views/authentication/signup";
import Login from "./views/authentication/login";
import ProtectedRoute from "./protectedRoute";
import { USER_ROLES } from "./utils";
import ResetPassword from "./views/authentication/resetPassword";
import Home from "./views/home";
import ResetPasswordInit from "./views/authentication/resetPasswordInit";
import Header from "./components/header.tsx";
import About from "./views/general/about";
import Privacy from "./views/general/privacy";
import MetaContainer from "./components/metaContainer/metaContainer";
import Join from "./views/join";
import UserGuide from "./views/general/user_guide";
import { lazy, Suspense } from "react";
import { socket } from "./context/socket-context";
const Admin = () => import("./views/admin/index.tsx");

// When the page visibility changes (for example, when a tab becomes inactive or active again)
// We check whether the tab is visible and the socket is connected, and reconnect if not.
document.addEventListener("visibilitychange", () => {
  if (!document.hidden && !socket.connected) {
    socket.connect();
  }
});

export default function App() {
  return (
    <BrowserRouter>
      <MetaContainer />
      <Routes>
        <Route
          path="/teacher/votingsession/:code/*"
          element={<TeacherSession />}
        />
        <Route path="/votingsession/:code/*" element={<StudentSession />} />
        <Route path="*" element={<MainRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

function MainRoutes() {
  return (
    <>
      <Header />
      <main className="page__content">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/join" element={<Join />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/user-guide" element={<UserGuide />} />
          <Route exact path="/privacy" element={<Privacy />} />
          <Route exact path="/register" element={<Signup />} />
          <Route exact path="/register/:token" element={<Signup />} />
          <Route
            exact
            path="/reset-password/init"
            element={<ResetPasswordInit />}
          />
          <Route exact path="/reset-password" element={<ResetPassword />} />
          <Route exact path="/login" element={<Login />} />

          <Route element={<ProtectedRoute requiredRole={USER_ROLES.TEACHER} />}>
            <Route exact path="/teacher" element={<GamesOverview />} />
            <Route exact path="/teacher/games/new" element={<NewGame />} />
            <Route
              exact
              path="/teacher/games/:id/edit"
              element={<EditGame />}
            />
          </Route>
          <Route
            element={<ProtectedRoute requiredRole={USER_ROLES.SUPER_ADMIN} />}
          >
            <Route path="/admin/*" element={<Lazy component={Admin} />} />
          </Route>
        </Routes>
      </main>
      <Footer />
    </>
  );
}

const Lazy = ({ component }) => {
  const Component = lazy(component);

  return (
    <Suspense>
      <Component />
    </Suspense>
  );
};
